import React from "react"
import { useNavigate } from "react-router-dom"

// styles
import { Wrapper, Content } from "./About.styles"
import Button from "../button/Button"

const About = () => {
  const navigate = useNavigate()

  const GoToContactPage = () => {
    navigate("/contact");
  }

  return (
    <Wrapper>
      <Content>
        <h1>About Me</h1>
        <p>
          I'm an independent <b>software developer</b> and <b>IT engineer</b>
          based in <b>Algeria</b>. I love creating beautiful looking
          <b> websites</b>, and consistent <b>software</b> for the benefit of the
          best user experience possible. And I consider myself to be completly
          blessed that i get to do it for a living.{" "}
        </p>
        <p>
          I have a master degree in Network and Data Engineering. I develope
          software since 2017.
        </p>
        <p>
          I started my coding career back then with purpos of continuously
          learning and developing my skills in software development,
          communication and marketing.
        </p>
        <p>
          If you are interested in collaboration feel free to leave message.
        </p>

        <Button type="button" text="Contact me" callback={GoToContactPage} />
      </Content>
    </Wrapper>
  )
}

export default About
